<script setup lang="ts">
import { PROJECT_COLORS, type ProjectColor } from '../../app/api/ProjectsApi.ts';

const model = defineModel<ProjectColor>({ required: true });
defineProps<{ label: string }>();
</script>

<template>
  <fieldset class="field">
    <legend class="field__label">{{ label }}</legend>
    <div class="color-picker">
      <label
        v-for="c in PROJECT_COLORS"
        :key="c"
        class="color-picker__swatch project-color"
        :class="`project-color--${c}`"
      >
        <input v-model="model" type="radio" name="project-color" :value="c" :aria-label="c" />
      </label>
    </div>
  </fieldset>
</template>
